
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/inscription/informations",
      function () {
        return require("private-next-pages/inscription/informations.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/inscription/informations"])
      });
    }
  